import React, {useState, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {Card, Carousel, Col, Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import StreamgraphChart2 from './components/StreamgraphChart2'

import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'

interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div>
        {/* begin::Row  */}

        <div className='card px-4'>
          <div className='card-body'>
            <h2 className='text-primary bold'>
              {' '}
              Viral load in wastewater - Covid-19 (Germany){' '}
              <OverlayTrigger
                placement='right'
                overlay={
                  <Tooltip id='logo-tooltip' style={{width: '300px'}}>
                    <p>
                      SARS-CoV-2 viral load is expressed as gene copies per liter wastewater. It is
                      determined by quantitative real-time PCR or digital droplet PCR. Data are
                      normalized to dry weather inflow. Quality control is performed by parallel
                      quantification of viruses known to originate from human faeces (e.g. the
                      bacteriophage CrAssphage or the plant virus Pepper-Mild-Mottle Virus (PMMoV)).
                      Data is updated on a weekly basis and smoothened using a locally weighted
                      regression method (LOESS). Source: RKI
                    </p>
                  </Tooltip>
                }
              >
                <img
                  style={{width: '12px', marginLeft: '10px'}}
                  alt='logo'
                  src={toAbsoluteUrl('/media/logos/ii.svg')}
                />
              </OverlayTrigger>
              {/* <i
                style={{color: 'red', marginLeft: '10%', fontSize: '20px'}}
                className='  fa-solid fa-arrow-up '
              ></i> */}
            </h2>
          </div>
          <Card.Body className='row' style={{marginTop: '-35px'}}>
            <StreamgraphChart />
            <p className='card-text source mt-2'>
              <i>
                Source:
                <a
                  className='fw-bold'
                  href='https://www.rki.de/DE/Content/Institut/OrgEinheiten/Abt3/FG32/Abwassersurveillance/Abwassersurveillance.html'
                >
                  {' '}
                  Robert Koch-Institut
                </a>
              </i>{' '}
            </p>
          </Card.Body>
        </div>
      </div>
    </>
  )
}
const DashboardPage2 = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-10'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'> Covid-19 - Variants of concern (France)</h2>

                <p className='card-text p-2 bg-secondary rounded'>
                  Some quick example text to build on the card title and make up the bulk of the
                  card's content.
                </p>
              </div>
              <Card.Body className='row '>
                <StreamgraphChart2 />
                <p className='card-text source'>
                  <img
                    className='mb-1'
                    style={{width: '12px'}}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                  <i>Source: Hospices Civils de Lyon, Laboratoire de biologie (LBMMS)</i>
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const Covid = () => {
  const intl = useIntl()
  return (
    <>
      <div className='mb-5'>
        <DashboardPage />
      </div>
      <div className='mb-5'>{/* <DashboardPage2 /> */}</div>
    </>
  )
}

export {Covid}
